import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { PatientsActionTypes } from 'src/store/patients/type';
import { fetchJson } from 'src/utils/fetch';
import format from 'src/utils/format';
import { DoctorActionTypes } from './type';

// function* fetch_doctor_list() {
//   while (true) {
//     const action = yield take(DoctorActionTypes.FETCH_DOCTOR_LIST);
//     try {
//       const { options } = action;
//       const res = yield call(fetchJson, {
//         url: '/api/api/v1/patient/doctor/list', type: 'POST', data: {
//           ...options
//         },
//         isloading: true,
//         action
//       });
//       if (res && res.code === '0') {
//         const { result = [] } = res;
//         const data: any[] = [];
//         result.length && result.forEach(element => {
//           data.push({
//             ...element,
//             avatar: `${element.headPortrait}` || "",
//             price: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].specialPrice) || 0,
//             productId: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].productId) || 0,
//           });
//         });
//         yield put({ type: DoctorActionTypes.FETCH_DOCTOR_LIST_SUCCESS, data });
//         result.length === 0 && StaticToast.warning('当前科室暂无医生接诊哦～');
//       }
//     } catch (error) {
//       StaticToast.error('网络异常，请稍后重试');
//       // StaticToast.error('fetch_doctor_list--------' + error.message);
//     }
//   }
// }

// function* fetch_doctor_list_page() {
//   while (true) {
//     const action = yield take(DoctorActionTypes.FETCH_DOCTOR_LIST_PAGE);
//     try {
//       const { options, onSuccess } = action;
//       const res = yield call(fetchJson, {
//         url: '/api/api/v1/patient/doctor/list/page', type: 'POST', data: {
//           ...options
//         },
//         action
//       });
//       if (res && res.code === '0') {
//         const { result: { resultList = [], totalPage = 1 } = {} } = res;
//         const data: any[] = [];
//         resultList.forEach(element => {
//           data.push({
//             ...element,
//             avatar: `${element.headPortrait}` || "",
//             specialPrice: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].realPrice) || 0,
//             price: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].specialPrice) || 0,
//             productId: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].productId) || 0,
//           });
//         });
//         typeof onSuccess === 'function' && onSuccess();
//         yield put({ type: DoctorActionTypes.FETCH_DOCTOR_LIST_PAGE_SUCCESS, data, totalPage: totalPage, currentPage: options.currentPage });
//       }
//     } catch (error) {
//       StaticToast.error('网络异常，请稍后重试');
//       // StaticToast.error('fetch_doctor_list_page--------' + error.message);
//     }
//   }
// }

// function* fetch_doctor_recommand() {
//   while (true) {
//     const action = yield take(DoctorActionTypes.FETCH_DOCTOR_RECOMMAND);
//     try {
//       const { options } = action;
//       const res = yield call(fetchJson, {
//         url: '/api/api/v1/patient/doctor/list/page',
//         type: 'POST',
//         data: {
//           ...options
//         },
//         needLogin: false,
//         isloading: false,
//         action
//       });
//       if (res && res.code === '0') {
//         const data: any[] = [];
//         const { result: { resultList = []} = {} } = res;
//         resultList.length && resultList.forEach(element => {
//           data.push({
//             ...element,
//             avatar: `${element.headPortrait}` || "",
//             price: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].specialPrice) || 0,
//             productId: (element.medicalStaffServiceList && element.medicalStaffServiceList[0].productId) || 0,
//           });
//         });
//         yield put({ type: DoctorActionTypes.FETCH_DOCTOR_RECOMMAND_SUCCESS, data });
//       }
//     } catch (error) {
//       StaticToast.error('网络异常，请稍后重试');
//       // StaticToast.error('fetch_doctor_recommand--------' + error.message);
//     }
//   }
// }

function* fetch_doctor_detail() {
  while (true) {
    const action = yield take(DoctorActionTypes.FETCH_DOCTOR_DETAIL);
    try {
      const { options, onSuccess } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/doctor/detail',
        type: 'POST',
        data: {
          ...options,
          option: {
            isQueryMedicalStaffService: true,
            isQueryHeadPortrait: true,
            isQueryHospital: true,
          },
        },
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
        // const avatar = (res.result.attachmentList && res.result.attachmentList.filter(i => i.attachmentType === "personalPhoto")) || [];
        const { medicalStaffServiceList = [] } = res.result;
        const productObj = medicalStaffServiceList.reduce((prev, cur) => {
          prev[`product${cur.productId}`] = cur;
          return prev;
        }, {});
        const [firstItem = {}] = medicalStaffServiceList;
        const data = {
          ...res.result,
          // avatar: `${avatar.length && avatar[0].attachmentDownloadUrl}` || "",
          price: firstItem.specialPrice || 0,
          productId: firstItem.productId || 0,
          ...productObj,
        };
        yield put({ type: DoctorActionTypes.FETCH_DOCTOR_DETAIL_SUCCESS, data });
        typeof onSuccess === 'function' && onSuccess(data);
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_doctor_detail--------' + error.message);
    }
  }
}

// function* fetch_doctor_evaluate() {
//   while (true) {
//     const action = yield take(DoctorActionTypes.FETCH_DOCTOR_EVALUTE);
//     try {
//       const { staffId, options, onSuccess } = action;
//       const res = yield call(fetchJson, {
//         url: '/api/api/v1/patient/docEvaluate/list/page', type: 'POST', data: {
//           staffId,
//           ...options
//         },
//         isloading: false,
//         action
//       });
//       if (res && res.code === '0') {
//         const { totalItem, rating, resultList = [], tags = '[]', totalPage, systemEvaluateNum = 0 } = res.result;
//         yield put({ type: DoctorActionTypes.FETCH_DOCTOR_EVALUTE_SUCCESS, totalItem, rating, data: resultList, tags: JSON.parse(tags), totalPage, currentPage: options.currentPage, systemEvaluateNum });
//         typeof onSuccess === 'function' && onSuccess();
//       }
//     } catch (error) {
//       StaticToast.error('网络异常，请稍后重试');
//       // StaticToast.error('fetch_doctor_evaluate--------' + error.message);
//     }
//   }
// }

function* init_my_doctor() {
  while (true) {
    const action = yield take(DoctorActionTypes.INIT_MY_DOCTOR);
    try {
      const { option } = action;
      const patientsRes = yield call(fetchJson, { url: '/api/api/v1/patient/patient/list',data: { option }, action, type: 'POST' });
      if (patientsRes.code === '0' && patientsRes.result.length > 0) {
        patientsRes.result.length &&
          patientsRes.result.forEach((element) => {
            element.age = element.patientBirthday ? format.GetAgeByBirthday(format.date(element.patientBirthday, 'yyyy-MM-dd')) : null;
            element.patientPhone_copy = element.patientPhone;
          });
        yield put({ type: PatientsActionTypes.FETCH_PATIENT_LIST_SUCCESS, data: patientsRes.result });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* fetch_my_doctor() {
  while (true) {
    const action = yield take(DoctorActionTypes.FETCH_MY_DOCTOR);
    try {
      const { patientId } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/doctor/list',
        action,
        type: 'POST',
        data: {
          patientId,
          staffTypes: ['doctor', 'advisoryDoctor'],
          option: {
            // isQueryMedicalStaffService: true,
            isQueryHeadPortrait: true,
          },
        },
      });
      if (res.code === '0' && res.result && res.result.length > 0) {
        const data: any[] = [];
        res.result.length &&
          res.result.forEach((element) => {
            data.push({
              ...element,
              avatar: element.headPortrait || '',
            });
          });
        yield put({ type: DoctorActionTypes.INIT_MY_DOCTOR_SUCCESS, data, patientId });
      } else {
        yield put({ type: DoctorActionTypes.INIT_MY_DOCTOR_SUCCESS, data: [], patientId });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
      // StaticToast.error('fetch_my_doctor--------' + error.message);
    }
  }
}

export default function* root() {
  yield all([
    // fork(fetch_doctor_list_page),
    // fork(fetch_doctor_evaluate),
    fork(fetch_doctor_detail),
    fork(fetch_my_doctor),
    // fork(fetch_doctor_list),
    // fork(fetch_doctor_recommand),
    fork(init_my_doctor),
  ]);
}
